const base = '/productlijnen'

module.exports = {
  'robuust robinia': `${base}/robuust-robinia`,
  'robuust staal': `${base}/robuust-staal`,
  'robuust design': `${base}/robuust-robinia`,
  'varioset mini': `${base}/robuust-robinia`,
  'kidstramps': `${base}/hightech`,
  'speelkunst': `${base}/speelkunst`,
  'hightech fun4all': `${base}/fun4all`,
  'hightech klimtollen': `${base}/hightech-klimtollen`,
  'hightech ruimtenetten': `${base}/hightech-ruimtenetten`,
  'tech&play': `${base}/tech-play`,
  'fun4all': `${base}/fun4all`
}
